import { Feather, Gift, Like, Coins } from "../components/images/svg/icons";

export const Benefits = [
  {
    icon: Feather,
    title: "BENEFIT_TITLE_1",
    description: "BENEFIT_TITLE_1_DESC",
  },
  {
    icon: Gift,
    title: "BENEFIT_TITLE_2",
    description: "BENEFIT_TITLE_2_DESC",
  },
  {
    icon: Like,
    title: "BENEFIT_TITLE_3",
    description: "BENEFIT_TITLE_3_DESC",
  },
  {
    icon: Coins,
    title: "BENEFIT_TITLE_4",
    description: "BENEFIT_TITLE_4_DESC",
  },
];
